const verticals = {
  indexTitle: 'GastroBuddy voor jouw type zaak',
  indexIntro:
    'Zelfde app, andere vloer. Kies je type zaak voor een korte uitleg, en start daarna je gratis maand.',
  pickLabel: 'Kies je zaak',
  cta: 'Start mijn gratis maand',
  ctaHint: 'Eerste maand gratis · Klaar in een paar minuten',
  seeGuides: 'Bekijk de horeca-gidsen →',
  seeCompare: 'Vergelijk met papier en spreadsheets →',
  otherVerticals: 'Andere typen zaken',
  restaurants: {
    label: 'Restaurants',
    metaTitle: 'GastroBuddy voor restaurants — vloer en gratis maand',
    metaDescription:
      'Checklists, kasafsluiting, recepten en teamvoortgang voor restaurants. Probeer GastroBuddy een maand gratis.',
    title: 'GastroBuddy voor restaurants',
    intro:
      'Voor drukke restaurants waar openen, sluiten, voedselveiligheid en prep niet alleen in een ringband mogen zitten.',
    painsTitle: 'Herkenbaar in de zaak',
    pains: {
      p1: 'Papieren lijsten die tijdens de service niemand bijwerkt',
      p2: 'Kas en fooien los van de taken op de vloer',
      p3: 'Recepten en mise en place die verouderen',
      p4: 'Nieuw personeel leert vooral door mee te lopen',
    },
    fitsTitle: 'Wat GastroBuddy daar mee doet',
    fits: {
      f1: 'Live takenlijsten voor openen, sluiten en tussendoor',
      f2: 'Kasregistratie en dagafsluiting in hetzelfde account',
      f3: 'Recepten en mise en place met keukencontext',
      f4: 'AI-assistent waarmee eigenaren lijsten en recepten uit chat maken',
    },
  },
  hotels: {
    label: 'Hotels',
    metaTitle: 'GastroBuddy voor hotels — F&B en vaste routines',
    metaDescription:
      'Stem hotel F&B- en ops-checklists af over diensten. GastroBuddy voor hotelteams, met gratis maand.',
    title: 'GastroBuddy voor hotels',
    intro:
      'Hotel F&B en facilities hebben vaste routines nodig over vestigingen en diensten. Zonder WhatsApp-achtervolgingen.',
    painsTitle: 'Wat hotelteams elke week voelen',
    pains: {
      p1: 'Verschillende vestigingen, dezelfde standaard, wisselende uitvoering',
      p2: 'Overdracht verdwijnt tussen nacht- en ochtendteam',
      p3: 'Checklists in drives die op de vloer niemand opent',
      p4: 'Managers jagen op afronden in plaats van bij gasten te zijn',
    },
    fitsTitle: 'Wat GastroBuddy daar mee doet',
    fits: {
      f1: 'Gedeelde taakvoortgang zonder de service te onderbreken',
      f2: 'Werken per locatie als je meerdere vestigingen hebt',
      f3: 'Open- en sluitlijsten plus facilitair op telefoon of tablet',
      f4: 'Webdashboard voor eigenaren en managers naast de apps',
    },
  },
  bars: {
    label: 'Bars',
    metaTitle: 'GastroBuddy voor bars — afsluiting, prep en teamlijsten',
    metaDescription:
      'Openen, sluiten, voorraadgerichte checklists en barrecepten. Probeer GastroBuddy een maand gratis.',
    title: 'GastroBuddy voor bars',
    intro:
      'Na last call gaat het hard. Afsluiting, bijvullen en barrecepten horen op de telefoon, niet in een la.',
    painsTitle: 'Typische bar-frictie',
    pains: {
      p1: 'Afsluiten hangt af van wie er gisteren werkte',
      p2: 'Garnish- en voorraadnotities verdwijnen in de groepschat',
      p3: 'Cocktailrecepten verschillen per medewerker',
      p4: 'Kas en fooien worden weer een apart gejakker',
    },
    fitsTitle: 'Wat GastroBuddy daar mee doet',
    fits: {
      f1: 'Sluitchecklists met duidelijke eigenaar per dienst',
      f2: 'Recepten met barcontext naast de taken op de vloer',
      f3: 'Kas en dagafsluiting op één plek',
      f4: 'Sneller inwerken van nieuwe bartenders met stappenplannen',
    },
  },
  cafes: {
    label: 'Cafés',
    metaTitle: 'GastroBuddy voor cafés — ochtendprep en dagelijkse ops',
    metaDescription:
      'Ochtendroutines, kwaliteitschecks en teamlijsten voor cafés. Start GastroBuddy met een gratis maand.',
    title: 'GastroBuddy voor cafés',
    intro:
      'Een caféochtend win of verlies je vóór de eerste espresso. Prep, schoonmaak en kassa-gereedheid horen op één lijst.',
    painsTitle: 'Café-realiteit',
    pains: {
      p1: 'Openen verschilt per persoon die de deur opent',
      p2: 'Gebak- en melkchecks sneuvelen zodra de rij begint',
      p3: 'Parttimers missen wat “iedereen wel weet”',
      p4: 'Papieren lijsten verdwijnen onder koffievlekken',
    },
    fitsTitle: 'Wat GastroBuddy daar mee doet',
    fits: {
      f1: 'Herhaalbare open- en sluitplannen voor iedereen',
      f2: 'Live voortgang zodat de closer ziet wat nog openstaat',
      f3: 'Recepten en preplijsten als je zelf bakt of batcht',
      f4: 'Nodig personeel uit wanneer jij wilt. Niet alles op dag één.',
    },
  },
  catering: {
    label: 'Catering',
    metaTitle: 'GastroBuddy voor catering — eventprep en teamchecklists',
    metaDescription:
      'Eventpreplijsten, mise en place en teamcoördinatie voor catering. Gratis maand GastroBuddy.',
    title: 'GastroBuddy voor catering',
    intro:
      'Catering draait op prep-windows en load-out-checklists. Zit de lijst in één hoofd, glijdt kwaliteit weg.',
    painsTitle: 'Waar cateringteams tegenaan lopen',
    pains: {
      p1: 'Eventpacks verschillen. Templates worden verkeerd gekopieerd.',
      p2: 'Load-in- en load-out-stappen sneuvelen onder tijdsdruk',
      p3: 'Keuken en bediening werken vanuit andere documenten',
      p4: 'Voortgang is lastig te zien bij een verspreid team',
    },
    fitsTitle: 'Wat GastroBuddy daar mee doet',
    fits: {
      f1: 'Herbruikbare takenlijsten per type event',
      f2: 'Mise en place en recepten voor productiekeukens',
      f3: 'Gedeelde voortgang als het team niet in één ruimte staat',
      f4: 'Tools voor eigenaren om snel lijsten te maken, ook via AI-chat',
    },
  },
} as const;

export default verticals;



// WEBPACK FOOTER //
// ./src/i18n/messages/segments/verticals.nl.ts